import { tv } from 'tailwind-variants';

export const tag = tv({
  base: 'text-card-color-default px-1 py-0.5 rounded-sm text-sm',
  variants: {
    variant: {
      primary: 'bg-color-brand-primary',
      secondary: 'bg-brand-color-secondary-pure',
      neutral: 'bg-mono-color-lighter text-mono-color-black',
      transparent: 'text-mono-color-black',
      white: 'bg-mono-color-white',
      alert: '',
      'embriologia-superior': 'bg-disciplina-embriologia-superior',
      'farmacologia-superior': 'bg-disciplina-farmacologia-superior',
      'fisiologia-superior': 'bg-disciplina-fisiologia-humana-superior',
      'genetica-superior': 'bg-disciplina-genetica-superior',
      'anatomia-superior': 'bg-disciplina-anatomia-humana-superior',
      'bioquimica-superior': 'bg-disciplina-bioquimica-superior',
      'histologia-superior': 'bg-disciplina-histologia-humana-superior',
      'histologia-humana-superior': 'bg-disciplina-histologia-humana-superior',
      'imunologia-superior': 'bg-disciplina-imunologia-superior',
      'parasitologia-superior': 'bg-disciplina-parasitologia-superior',
      'patologia-superior': 'bg-disciplina-patologia-superior',
      'microbiologia-superior': 'bg-disciplina-microbiologia-superior',
      incidencia1: 'bg-incidencia-n1',
      incidencia2: 'bg-incidencia-n2',
      incidencia3: 'bg-incidencia-n3',
      incidencia4: 'bg-incidencia-n4',
      incidencia5: 'bg-incidencia-n5',
    },
  },
});
